<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <!-- HEADER -->
          <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">
              Détails de la proposition
            </h4>
            <router-link to="/liste-propositions" class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              Retour
            </router-link>
          </div>

          <!-- INFORMATIONS GENERALES -->
          <table class="table">
            <tbody>
              <tr v-if="proposition?.contenu">
                <td>Contenu :</td>
                <td>{{ proposition.contenu }}</td>
              </tr>
              <tr v-if="proposition">
                <td>Est la bonne réponse :</td>
                <td>{{ proposition.estLaBonneReponse == 1 ? 'Oui' : 'Non' }}</td>
              </tr>

              <tr v-if="proposition?.question?.contenu">
                <td>Question :</td>
                <td>{{ proposition.question?.contenu }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { error, format_Date } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewProposition",
  setup() {
    const route = useRoute();
    const proposition = ref<any>(null);

    // 🔹 Chargement du proposition
    const getProposition = async (id: string) => {
      try {
        const { data } = await ApiService.get(`/propositions/question/${id}`);
        proposition.value = data.data;
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement du proposition.");
      }
    };

    onMounted(() => {
      const id = route.params.id as string;
      if (id) getProposition(id);
    });

    return {
      proposition,
      format_Date,
    };
  },
});
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
</style>
